import { createSelector } from '@reduxjs/toolkit';
import selectWishlistPageActions from '@spa/lib/store/wishlists/selectors/selectWishlistPageActions';

const selectSucceededDeleteProductFromMyWishlistActionIds = createSelector(
  [selectWishlistPageActions],
  (wishlistsPageActions): ReadonlyArray<number> =>
    wishlistsPageActions.deleteProductFromMyWishlist.succeeded.map(
      (action): number => action.requestedActionId
    )
);

export default selectSucceededDeleteProductFromMyWishlistActionIds;
